module.exports = __webpack_public_path__ + "static/media/livechat-full.1771bbd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/livechat-full.svg
// module id = 825
// module chunks = 0